import React, { useState, useEffect } from 'react';
import logo1 from '../../../assets/corporate_logos/1.png';
import logo2 from '../../../assets/corporate_logos/2.png';
import logo3 from '../../../assets/corporate_logos/3.png';
import logo4 from '../../../assets/corporate_logos/4.png';
import logo5 from '../../../assets/corporate_logos/5.png';

const Testimonials = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const logos = [logo1, logo2, logo3, logo4, logo5];

  const reviews = [
    {
      quote: "Pulpit Cabs has completely transformed our employee commute logistics. The automated billing alone has saved our finance team 20 hours a month, and the level of service is unmatched.",
      author: "Jonathan Sterling",
      role: "VP of Operations, TechVista Solutions"
    },
    {
      quote: "The safety features for our late-shift employees, especially the SOS button and live tracking, have given us absolute peace of peace. Highly recommend their ETS solutions for any modern enterprise.",
      author: "Ananya Sharma",
      role: "HR Director, FinEdge India"
    },
    {
      quote: "Pulpit's tech stack is impressive. We've seen a 30% reduction in our overall transportation costs due to their AI-driven route optimization. Truly a game-changer for large scale operations.",
      author: "Rajesh Malhotra",
      role: "Logistics Manager, Infratech Solutions"
    },
    {
      quote: "The transition to Pulpit Cabs was seamless. Their team handled our complex multi-city requirements with professional ease. The vehicle quality is consistently premium and reliable.",
      author: "Michael Chen",
      role: "Operations Head, Eco-Systems Ltd"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev === reviews.length - 1 ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(timer);
  }, [reviews.length]);

  const nextSlide = () => {
    setActiveIndex((prev) => (prev === reviews.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setActiveIndex((prev) => (prev === 0 ? reviews.length - 1 : prev - 1));
  };

  return (
    <section className="py-[40px] bg-surface-container-lowest overflow-hidden border-t border-outline-variant/10">
      <div className="max-w-[1400px] mx-auto px-[32px]">
        {/* Trusted By Section */}
        <div className="mb-[56px] flex flex-col items-center">
          <div className="text-center mb-[32px] w-full flex flex-col items-center">
            <h2 className="font-headline text-[30px] font-extrabold tracking-tight text-on-surface mb-[16px]">Trusted by 500+ Indian Enterprises</h2>
            <div className="w-[64px] h-[4px] bg-primary mb-[32px]"></div>
            <p className="text-on-surface-variant max-w-[672px] mx-auto text-center">We partner with industry leaders to deliver mission-critical transportation solutions that power their daily operations.</p>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-[32px] md:gap-[48px] w-full">
            {logos.map((logo, i) => (
              <div
                key={i}
                className="relative h-[64px] w-auto flex items-center justify-center grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-500 cursor-default group"
              >
                <img
                  src={logo}
                  alt={`Trusted Company ${i + 1}`}
                  className="max-h-full max-w-[140px] object-contain group-hover:scale-110 transition-transform duration-300"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Testimonials Slider */}
        <div className="mt-[56px] max-w-[896px] mx-auto relative group">
          <div className="text-center mb-[48px]">
            <span className="text-primary font-bold text-[14px] uppercase tracking-[0.2em] mb-[8px] block">Success Stories</span>
            <h3 className="font-headline text-[30px] font-bold">What Our Partners Say</h3>
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={prevSlide}
            className="absolute left-[0px] top-1/2 -translate-y-1/2 -translate-x-12 opacity-0 group-hover:opacity-100 group-hover:-translate-x-16 transition-all duration-300 z-20 w-[48px] h-[48px] rounded-full border border-outline-variant/30 bg-background shadow-lg flex items-center justify-center text-primary hover:bg-primary hover:text-white"
          >
            <span className="material-symbols-outlined">chevron_left</span>
          </button>

          <button
            onClick={nextSlide}
            className="absolute right-[0px] top-1/2 -translate-y-1/2 translate-x-12 opacity-0 group-hover:opacity-100 group-hover:translate-x-16 transition-all duration-300 z-20 w-[48px] h-[48px] rounded-full border border-outline-variant/30 bg-background shadow-lg flex items-center justify-center text-primary hover:bg-primary hover:text-white"
          >
            <span className="material-symbols-outlined">chevron_right</span>
          </button>

          <div className="bg-surface-container-low p-[48px] rounded-[24px] relative border border-outline-variant/10 min-h-[350px] flex flex-col justify-center shadow-xl">
            <span className="material-symbols-outlined text-[60px] text-primary/10 absolute top-[32px] left-[32px]">format_quote</span>

            <div className="relative z-10">
              <div className="overflow-hidden">
                <div
                  className="flex transition-transform duration-500 ease-in-out"
                  style={{ transform: `translateX(-${activeIndex * 100}%)` }}
                >
                  {reviews.map((review, i) => (
                    <div key={i} className="w-full flex-shrink-0 px-[16px]">
                      <p className="font-headline text-[24px] font-medium leading-relaxed italic mb-[32px] text-brand-grey-800">
                        "{review.quote}"
                      </p>
                      <div className="flex items-center gap-[16px]">
                        <div className="w-[48px] h-[48px] rounded-full bg-primary/10 flex items-center justify-center text-primary">
                          <span className="material-symbols-outlined">person</span>
                        </div>
                        <div>
                          <div className="font-bold text-on-surface">{review.author}</div>
                          <div className="text-[14px] text-brand-grey-600">{review.role}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Dots */}
            <div className="flex justify-center gap-[8px] mt-[48px]">
              {reviews.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setActiveIndex(i)}
                  className={`w-[8px] h-[8px] rounded-full transition-all duration-300 ${i === activeIndex ? 'bg-primary w-[24px]' : 'bg-brand-grey-400 hover:bg-brand-grey-500'}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;


